import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { LayerType } from '@mirage-projects/cw-models';
import { JobPcvizService } from '@mirage-projects/cw-pcviz-core';

import { UploadWizardService } from '../../../services/upload-wizard-service/upload-wizard.service';
import { UavImportOptions } from './uav-import-options';

/**
 * UAV options import
 * This component is used as an optional step in the layer creation to set the UAV options
 */
@Component({
    selector: 'cw-uav-import-options',
    templateUrl: 'uav-import-options.component.html',
    standalone: false,
})
export class UavImportOptionsComponent implements OnInit, OnDestroy {
    options: UavImportOptions = this.uploadWizardService.uavConversion;
    onDestroy$: Subject<void> = new Subject();

    constructor(
        private uploadWizardService: UploadWizardService,
        private jobAdapterService: JobPcvizService
    ) {}

    ngOnInit(): void {
        this.uploadWizardService.stepChanged.subscribe(() => {
            this.updateSummary();
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    private updateSummary(): void {
        const dataType: LayerType | undefined = this.jobAdapterService.getJobAdapter()?.getLayerType();
        if (!dataType) {
            return;
        }

        const skipImages: string = this.options.skipImages ? 'GENERAL.YES' : 'GENERAL.NO';

        this.uploadWizardService.summary[2] = {
            dataType,
            title: 'WIZARD.TAB_UAV_CONFIGURATION',
            fields: [{ key: 'UPLOAD.SKIP_NO_METADATA_IMAGES', value: skipImages }],
        };
    }
}
